/* eslint-disable no-console, no-debugger */
import keen from '@/analytics/keen'
import AuthorHeader from '@/components/AuthorHeader.vue'
import TCheckbox from '@/components/Checkbox/Checkbox.vue'
import FormControl from '@/components/FormControl.vue'
import FormControlError from '@/components/FormControlError.vue'
// ui
import TInput from '@/components/Input/Input.vue'
import LoadingButtonIcon from '@/components/LoadingButtonIcon.vue'
import PageHeader from '@/components/PageHeader.vue'
import Popover from '@/components/Popover.vue'
import TOption from '@/components/Select/Option.vue'
import TSelect from '@/components/Select/Select.vue'
import LoadingDirective from '@/directives/loading'
import { errorNotification } from '@/notifications'
import { isPortalEnabled, redirectToPortalLogin } from '@/auth-portal'
import * as settings from '@/settings'
import store from '@/store'
import Icon from '@frontend/icons'
import 'flatpickr/dist/flatpickr.css'
import Echo from 'laravel-echo'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import 'svgxuse/svgxuse.js'
import LoadingIcon from 'tellimer-loading-icon'
import VueClickOutside from 'v-click-outside'
import VueTooltip from 'v-tooltip'
import velocity from 'velocity-animate'
import Vue from 'vue'
import VueApollo from 'vue-apollo'
// date picker
import VueFlatPickr from 'vue-flatpickr-component'
import VueFriendlyIframe from 'vue-friendly-iframe'
import VueModal from 'vue-js-modal'
import VueMeta from 'vue-meta'
import Multiselect from 'vue-multiselect'
import Notifications from 'vue-notification'
import VueProgressBar from 'vue-progressbar'
import VueScrollTo from 'vue-scrollto'
import { apolloClient } from './apollo'
import App from './App.vue'
import axios from './axios'
import login from './login'
import router from './router'

if (process.env.NODE_ENV === 'production') {
  Raven.config('https://8aaa113cdf694b83b13af38e0e2926b1@sentry.io/1420693')
    .addPlugin(RavenVue, Vue)
    .install()
} else {
  console.warn(
    'Sentry error tracking not enabled for environment:',
    process.env.NODE_ENV
  )
}

(window as any).io = require('socket.io-client')
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$login = login
Vue.prototype.$portalUrl = process.env.VUE_APP_PORTAL_URL
Vue.prototype.$echo = new Echo({
  broadcaster: 'socket.io',
  host: process.env.VUE_APP_SOCKET_IO
})
Vue.prototype.$keen = keen
Vue.prototype.$settings = settings

Vue.use(VueApollo)
Vue.use(VueProgressBar, {
  color: '#7793a7',
  failedColor: '#b03838',
  transition: { speed: '0.2s', opacity: '0.6s', termination: 750 }
})
Vue.use(VueTooltip, {
  defaultOffset: 0
})
Vue.use(VueModal)
Vue.use(Notifications, {velocity})

Vue.component('t-input', TInput)
Vue.component('t-checkbox', TCheckbox)
Vue.component('t-select', TSelect)
Vue.component('t-option', TOption)
Vue.component('vue-friendly-iframe', VueFriendlyIframe)
Vue.use(VueFlatPickr);
Vue.use(VueFriendlyIframe);

Vue.use(VueMeta)
Vue.use(Icon, {
  sprites:
    process.env.VUE_APP_ICON_URL || 'https://s3-eu-west-1.amazonaws.com/exotix-cdn/icons/dev.svg'
})
// Vue.use(HtmlEditor, {
//   config: function() {
//     return {
//       requestHeaders: {
//         Authorization: 'Bearer ' + login.getToken()
//       },
//       key: process.env.VUE_APP_FROALA_KEY || '',
//       imageUploadURL: process.env.VUE_APP_API_ENDPOINT + 'upload/image',
//       fileUploadURL: process.env.VUE_APP_API_ENDPOINT + 'upload/file'
//     }
//   }
// })

Vue.use(LoadingIcon)
Vue.use(VueScrollTo)

Vue.component('form-control', FormControl)
Vue.component('form-control-error', FormControlError)
Vue.component('loading-button-icon', LoadingButtonIcon)
Vue.component('page-header', PageHeader)
Vue.component('author-header', AuthorHeader)
Vue.component('multiselect', Multiselect)
Vue.component('popover', Popover)
Vue.directive('clickOutside', VueClickOutside.directive)
Vue.directive('loading', LoadingDirective)


const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})
const createVue = () => {
  return new Vue({
    el: '#app',
    router,
    store,
    methods: {
      async userCheck() {
        if (this.$login.getToken()) {
          try {
            await axios.get('/user')
          } catch (e) {
            this.$login.logout()
            if (isPortalEnabled()) {
              redirectToPortalLogin(this.$route.fullPath)
              return
            }
            this.$notify(
              errorNotification('You have been logged out due to inactivity.')
            )
          }
        }

        setTimeout(this.userCheck, 30000)
      },
    },
    apolloProvider,
    beforeMount() {
      this.userCheck()
      this.$store.dispatch('channels/getChannels')

      axios.interceptors.response.use(
        (response) => response,
        (error) => {
          // this.$Progress.fail()
          const errors =
            error.response && error.response.data.errors
              ? error.response.data.errors
              : null
          let errorStr = ''

          if (error.response.code === 401) {
            window.location.reload()
          }

          if (errors) {
            for (const key in errors) {
              if (errors[key]) {
                errorStr +=
                  errors && errors[key]
                    ? '<li>' +
                      (typeof errors[key] === 'string'
                        ? errors[key]
                        : errors[key][0]) +
                      '</li>'
                    : ''
              }
            }
          }

          // TODO:
          this.$notify(
            errorNotification(
              errorStr
                ? `</br><ul>${errorStr}</ul>`
                : error.response && error.response.data.message
                ? `${error.response.data.message}`
                : 'Error'
            )
          )


          return Promise.reject(error)
        }
      )
    },
    render: (h) => h(App)
  })
}

// Setup globally synced timeframe variable for analytics pages
const setupTimeframe = () => {
  const analyticsData = new Vue({
    data: { $timeframe: 'this_7_days' }
  })

  Vue.mixin({
    computed: {
      $timeframe: {
        get: function() {
          return analyticsData.$data.$timeframe
        },
        set: function(timeframe) {
          analyticsData.$data.$timeframe = timeframe
        }
      }
    }
  })
}

const done = (response: any = { status: 0 }) => {
  if (response.status !== 200) {
    login.setToken(null)
  } else {
    login.setUser(response.data)
  }

  const script = document.createElement('script')
  script.src =
    'https://maps.googleapis.com/maps/api/js?key=' +
    process.env.VUE_APP_GOOGLE_API_KEY +
    '&libraries=places'
  document.head.appendChild(script)
  createVue()
  setupTimeframe()
}

login.init()
    axios
      .get('user')
      .then(done)
      .catch(done)
